import { useDeleteAssign, useGetAssigns } from '@vindr/services/actions/assign.action';
import { ResponseGetOrders } from '@vindr/services/apis/order.api';
import { MESSAGE } from '@vindr/services/constants/message.constant';
import { Button } from 'antd';
import { MessageInstance } from 'antd/es/message/interface';
import { ModalStaticFunctions } from 'antd/es/modal/confirm';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import EditAssign from './EditAssign';
import useAssignedColumns from './useAssignedColumns';
import { Table } from '@vindr/ui';

const AssignedForm = ({
  order,
  onCancel,
  message,
  modal,
}: {
  order: ResponseGetOrders['data']['0'];
  onCancel: () => void;
  message: MessageInstance;
  modal: Omit<ModalStaticFunctions, 'warn'>;
}) => {
  const { t } = useTranslation('Vindoc');

  const [editingAssign, setEditingAssign] = useState(null);
  const [isEditingAssign, setIsEditingAssign] = useState(false);

  const { mutateAsync: deleteAssign } = useDeleteAssign();

  const handleRemove = (record) => {
    modal.confirm({
      className: 'delete-modal',
      title: t(MESSAGE.DIALOG.CFD_17000),
      okText: t('Delete'),
      zIndex: 1200,
      onOk: () => {
        deleteAssign(
          { id: record?.id },
          {
            onSuccess: () => {
              message.success(t(MESSAGE.SUCCESS.SCD_17003));
            },
            onError: (error: any) => {
              const error_message =
                (error?.response?.data?.error_code &&
                  MESSAGE.ERROR[error?.response?.data?.error_code]) ||
                'Delete error';

              message.error(t(error_message));
            },
          }
        );
      },
    });
  };

  const handleEdit = (record) => {
    setEditingAssign(record);
    setIsEditingAssign(true);
  };

  const assignList =
    useGetAssigns({ offset: 0, limit: 100, order_id: order?.id })?.data?.data || [];

  const assignedColumns = useAssignedColumns({
    onRemove: handleRemove,
    onEdit: handleEdit,
  });

  return (
    <div className="flex w-full flex-col">
      <Table
        columns={assignedColumns}
        dataSource={[...assignList]}
        scroll={{ y: 500 }}
        pagination={null}
      />

      <EditAssign
        assignData={editingAssign}
        isEditing={isEditingAssign}
        onFinish={() => {
          setEditingAssign(null);
          setIsEditingAssign(false);
        }}
        message={message}
      />

      <div className="footer mt-3 flex justify-end">
        <Button onClick={onCancel}>{t('Cancel')}</Button>
      </div>
    </div>
  );
};

export default AssignedForm;
